export default {
	systemTabs: [
		{ name: 'Cards', index: 1 },
		{ name: 'Home', index: 2 },
		{ name: 'Settings', index: 3 }
	]
}
